import React, { useEffect } from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ReceivedModal from "../../../../Components/Modals/Banking/Received/ReceivedModal";
import { fetchAllBankingListings } from "../../../../Redux/Slices/bankingSlice";

const ActiveLedgerPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const id = searchParams.get("id");

  const allListings = useSelector(
    (state) => state?.bankingSlice?.allListings || []
  );

  // Find the listing by ID to get the actual name
  const currentListing = allListings.find(
    (listing) => listing.id === parseInt(id, 10)
  );
  const actualListingName = currentListing?.name;

  useEffect(() => {
    // Fetch all listings if not already loaded
    if (allListings.length === 0) {
      dispatch(fetchAllBankingListings());
    }
  }, [dispatch, allListings.length]);

  useEffect(() => {
    if (id && !location.state?.initialTab) {
      const newState = {
        ...location.state,
        initialTab: "Active Connection",
        listingId: parseInt(id, 10),
        listingName: location.state?.listingName || actualListingName,
      };

      window.history.replaceState(
        newState,
        "",
        location.pathname + location.search
      );
    }
  }, [
    id,
    location.state,
    location.pathname,
    location.search,
    actualListingName,
  ]);

  const handleClose = () => {
    // Check if user came from banking ledger
    if (location.state?.fromBankingLedger) {
      navigate("/banking_ledger", {
        state: {
          activeTab: location.state?.activeTab,
        },
      });
    } else {
      navigate("/banking");
    }
  };

  return <ReceivedModal open={true} handleClose={handleClose} />;
};

export default ActiveLedgerPage;
